__webpack_require__.p = "/Wahmy-Burger-Restaurant/";